import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ButtonLink } from './ButtonLink';
import { NameSignature } from './NameSignature';
export function Hero() {
  const reduceMotion = useReducedMotion();
  const scrollToSection = (event: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    event.preventDefault();
    const target = document.getElementById(sectionId);
    if (!target) return;
    const headerOffset = 88;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  };
  const item = (delay: number) => ({
    initial: reduceMotion ? false : {
      opacity: 0,
      y: 12
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.28,
      delay,
      ease: [0.22, 1, 0.36, 1]
    }
  });
  return <section className="relative isolate min-h-[650px] overflow-hidden pt-32 md:min-h-[720px] md:pt-40" data-id="element-314" data-mp="3d2lapfhgtb2a">
      <div aria-hidden="true" className="hero-dot-grid absolute inset-0 opacity-60" data-id="element-315" data-mp="381e61pamcrzu" />

      <div className="site-container relative flex min-h-[650px] flex-col items-center justify-center pb-20 text-center md:min-h-[720px] md:pb-28" data-id="element-316" data-mp="3j897lcz58bpj">
        <motion.p {...item(0.05)} className="mb-7 font-display text-sm font-medium uppercase tracking-[0.14em] text-muted" data-id="element-317" data-mp="3o5j2h85axfkr">
          Currently residing in St. Petersburg, FL
        </motion.p>

        <motion.div {...item(0.1)} className="w-full text-foreground" data-id="element-318" data-mp="30iaziwvciilw">
          <NameSignature data-id="element-319" data-mp="30fy9rxjcj3ya" />
        </motion.div>

        <motion.h1 {...item(0.16)} className="mt-12 max-w-3xl text-balance font-sans text-2xl font-medium leading-[1.16] tracking-[-0.025em] md:text-3xl lg:text-4xl" data-id="element-320" data-mp="358zq89z7bbjz">
          Product Designer, visual connoisseur, and a minimalist at heart.
        </motion.h1>

        <motion.p {...item(0.22)} className="mt-7 max-w-2xl text-lg leading-relaxed text-muted md:text-xl" data-id="element-321" data-mp="2hinc2hdd4iky">
          I craft clear, elegant digital products that make complex systems feel simple, useful, and easy to navigate.
        </motion.p>

        <motion.div {...item(0.28)} className="mt-10 flex flex-wrap items-center justify-center gap-x-7 gap-y-4" data-id="element-322" data-mp="s3cmgcr3vnrm">
          <ButtonLink href="#work" onClick={event => scrollToSection(event, 'work')} data-id="element-323" data-mp="n9i4bdr5fgun">
            View selected work
          </ButtonLink>
          <ButtonLink href="#about" variant="text" onClick={event => scrollToSection(event, 'about')} data-id="element-324" data-mp="ddwwv03b9odi">
            About me
          </ButtonLink>
        </motion.div>
      </div>
    </section>;
}